exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-msg[data-v-658a1c71]{margin:10px 0 20px 0;font-size:14px;color:#f5222d;text-align:center;width:360px}", ""]);

// exports
